import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Checkbox from '../field/checkbox';

const checkboxes = [
  {
    label: 'No Preference',
    value: ''
  },
  {
    label: 'Yes',
    value: 1
  },
  {
    label: 'No',
    value: 0
  }
];

function RenderCheckbox(props) {
  const { input, meta, ...checkboxProps } = props;
  const checked = input.value === props.value;

  return (
    <Checkbox
      {...checkboxProps}
      type="radio"
      checked={checked}
      onChange={e => {
        const { checked, value } = e.target;

        var newValue = checked ? value : '';

        return input.onChange(newValue);
      }}
    />
  );
}

class PreferenceFilter extends PureComponent {
  static contextTypes = {
    theme: PropTypes.object
  };

  render() {
    const BS = this.context.theme;
    const { className, ...props } = this.props;

    return (
      <div className={`${BS.justifyContentSpaceBetween} ${BS.dFlex} ${BS.flexWrap}`}>
        {checkboxes.map(function (checkbox, i) {
          return (
            <RenderCheckbox
              {...props}
              key={i}
              value={checkbox.value !== undefined ? checkbox.value : checkbox}
              label={checkbox.label || checkbox}
            />
          );
        })}
      </div>
    );
  }
}
export default PreferenceFilter;



// WEBPACK FOOTER //
// ./src/components/form/filter/preference-filter.js